import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { DirectivesModule } from '@starley/ion-directives';
import { CnpjPipe } from '../pipes/cnpj.pipe';
import { CpfPipe } from '../pipes/cpf.pipe';
import { PrecoVendaPipe } from '../pipes/preco-venda.pipe';
import { SearchfilterPipe } from '../pipes/searchfilter.pipe';
import { TelefonePipe } from '../pipes/telefone.pipe';
// import { MmBarcodeScannerComponent } from './mm-barcode-scanner/mm-barcode-scanner.component';
import { MmCheckInComponent } from './mm-check-in/mm-check-in.component';
import { MmDataFilterComponent } from './mm-data-filter/mm-data-filter.component';
import { MmImagePreviewComponent } from './mm-image-preview/mm-image-preview.component';
import { MmInfoOfferComponent } from './mm-info-offer/mm-info-offer.component';
import { MmLeftColumnComponent } from './mm-left-column/mm-left-column.component';
import { MmLegiblePhotoComponent } from './mm-legible-photo/mm-legible-photo.component';
import { MmMenuFooterComponent } from './mm-menu-footer/mm-menu-footer.component';
import { MmMenuHeaderComponent } from './mm-menu-header/mm-menu-header.component';
import { MmMultiluckModalComponent } from './mm-multiluck-modal/mm-multiluck-modal.component';
import { MmOnboardingComponent } from './mm-onboarding/mm-onboarding.component';
import { MmRightColumnComponent } from './mm-right-column/mm-right-column.component';
import { MmRouletteModalComponent } from './mm-roulette-modal/mm-roulette-modal.component';
import { MmProductStoreListComponent } from './mm-store/mm-product-store-list/mm-product-store-list.component';
import { MmSearchStoreComponent } from './mm-store/mm-search-store/mm-search-store.component';
import { MmUnderMaintenanceComponent } from './mm-under-maintenance/mm-under-maintenance.component';
import { MmUserAddressComponent } from './mm-user-address/mm-user-address.component';
import { MmUpdateAppComponent } from './mm-update-app/mm-update-app.component';

const PAGES_COMPONENTES = [
    MmMenuHeaderComponent,
    MmMenuFooterComponent,
    MmRightColumnComponent,
    MmLeftColumnComponent,
    MmDataFilterComponent,
    MmSearchStoreComponent,
    MmProductStoreListComponent,
    MmOnboardingComponent,
    SearchfilterPipe,
    TelefonePipe,
    PrecoVendaPipe,
    CpfPipe,
    CnpjPipe,
    MmLegiblePhotoComponent,
    MmImagePreviewComponent,
    MmUnderMaintenanceComponent,
    MmMultiluckModalComponent,
    MmRouletteModalComponent,
    MmUserAddressComponent,
    MmInfoOfferComponent,
    MmUpdateAppComponent,
    MmCheckInComponent
]

@NgModule({
    imports: [CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        ScrollingModule,
        DirectivesModule,

    ],
    declarations: [
        PAGES_COMPONENTES,
    ],
    exports: [
        PAGES_COMPONENTES
    ],
    providers: [
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class CustomComponentModule { }
